import {useEffect} from 'react'

export const useCarouselObserver = (callback) => {
    useEffect(() => {
        const observer = new MutationObserver(() => {
            const totalCarousels = document.querySelectorAll(
                '[data-testid="product-carousel"]'
            ).length
            const initializedCarousels = document.querySelectorAll('.slick-initialized').length

            if (totalCarousels > 0 && initializedCarousels === totalCarousels) {
                callback?.()
            }
        })

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        })

        return () => observer.disconnect()
    }, [callback])
}
